export default {
  props: ['id'],
  data() {
    return {
      step: 0,
      questions: [],
      isValid: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    isSeminar() {
      return this.$route?.query?.from === 'seminars';
    },
    owner() {
      if (this.isSeminar) {
        return this.$store.state.seminars.seminarForTest;
      }
      return this.$store.state.courses.course;
    },
    test() {
      return this.owner.tests?.[0] || this.owner.test;
    },
    try() {
      return this.$store.state.courses.try;
    },
  },
  watch: {
    try(t) {
      this.step = t.step;
    },
  },
  methods: {
    setQuestions() {
      if (this.test.questions.length) {
        this.questions = [];
        for (let i = 0; i < this.test.questions.length; i += 1) {
          this.questions.push({
            ...this.test.questions[i],
            answer: {
              id: this.test.questions[i].id,
              checked: !this.test.questions[i].isSingleAnswer ? [] : 0,
            },
            isValid: false,
          });
        }
      }
    },
    showTest() {
      return this.try && this.questions.length;
    },
    questionValidate(item) {
      let isValid = false;
      if (item.isSingleAnswer && item.answer.checked) {
        isValid = true;
      }
      if (!item.isSingleAnswer && item.answer.checked.length) {
        isValid = true;
      }
      item.isValid = isValid;
      return isValid;
    },
    nextStep(qid, aid, isLast) {
      const app = this;
      const answer = {
        profile_id: this.user.profile_id,
        try_id: this.try.id,
        question_id: qid,
        answer_ids: Array.isArray(aid) ? aid : [aid],
      };
      app.$store.getters.axl
        .post('courses/api/test-try/answer', answer)
        .then((response) => {
          response.data.try.test_id = this.try.test_id;
          app.$store.commit('courses/setTry', response.data.try);
          app.step += 1;
          if (isLast) {
            this.$router.push({
              path: `/results/${this.test.id}`,
              query: { from: this.$route?.query?.from },
            });
          }
        })
        .catch((error) => {
          if (
            error.response
            && error.response.status === 301
            && error.response.data.redirect
          ) {
            app.$router.push({
              path: `/results/${this.try.test_id ?? ''}`,
              query: { from: this.$route?.query?.from },
            });
          } else if (error.response && error.response.status === 400) {
            if (this.isSeminar) {
              app.$router.push('/seminars/');
            } else {
              app.$router.push(`/course/${app.owner.id}`);
            }
          }
        });
    },
  },
  async mounted() {
    this.$store.dispatch('courses/startTry', {
      profile_id: this.user.profile_id,
      test_id: this.test.id,
    });
    this.step = this.try && this.try.step ? this.try.step : 1;
    this.setQuestions();
  },
};
